<div class="dashboard-container">
  <!-- Header -->
  <div class="dashboard-header">
    <h1>CTM Dashboard</h1>
    <p class="subtitle">CTM metrics and overview</p>
  </div>

  <!-- Date Range Picker -->
  <div class="date-range-section">
    <mat-form-field>
      <mat-label>Start Date</mat-label>
      <input
        matInput
        [matDatepicker]="startPicker"
        [formControl]="range.controls.start"
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="startPicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field>
      <mat-label>End Date</mat-label>
      <input
        matInput
        [matDatepicker]="endPicker"
        [formControl]="range.controls.end"
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="endPicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
    </mat-form-field>

    <button
      mat-raised-button
      color="primary"
      (click)="applyDateChange()"
      [disabled]="range.invalid"
    >
      <mat-icon>refresh</mat-icon>
      Apply
    </button>
  </div>

  <!-- Tables Section -->
  <div class="tables-section">
    <!-- Left Sidebar with table list -->
    <div class="tables-sidebar">
      <h2 class="sidebar-title">Reports</h2>
      <div class="table-list">
        @for (config of tableConfigs; track config.id) {
          <button
            class="table-item"
            [class.active]="selectedTable === config.id"
            (click)="selectTable(config.id)"
          >
            {{ config.name }}
          </button>
        }
      </div>
    </div>

    <!-- Main content area for selected table -->
    <div class="table-content">
      @if (isChartView) {
        <!-- Chart view (e.g. Monthly Sales) -->
        <mat-card class="chart-card" appearance="outlined">
          <mat-card-content>
            @if (isTableLoading) {
              <div class="loading">Loading...</div>
            } @else if (currentChartOptions.series) {
              <highcharts-chart
                [Highcharts]="Highcharts"
                [constructorType]="chartConstructor"
                [options]="currentChartOptions"
                [update]="updateFlag"
                style="width: 100%; display: block"
              >
              </highcharts-chart>
            } @else {
              <div class="no-data">No data available</div>
            }
          </mat-card-content>
        </mat-card>
      } @else if (isMultiTableView()) {
        <!-- Multi-table view -->
        <div class="multi-table-view">
          <h2 class="section-title">{{ getCurrentTableTitle() }}</h2>
          <div class="multi-table-grid">
            @for (tableItem of multiTableData; track $index) {
              <div class="table-section">
                <app-data-table
                  [tableData]="tableItem.data"
                  [isLoading]="tableItem.isLoading"
                  [title]="tableItem.data?.label || tableItem.name"
                >
                </app-data-table>
              </div>
            }
          </div>
        </div>
      } @else {
        <!-- Single table view -->
        <app-data-table
          [tableData]="currentTableData"
          [isLoading]="isTableLoading"
          [title]="getCurrentTableTitle()"
        >
        </app-data-table>
      }
    </div>
  </div>
</div>
